import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { resetJourney } from '@/store/reset';

export interface GocardlessState {
  bank: string,
  billingDay: string,
  sortCode: string,
  accountNumber: string,
  accountHolderName: string,
  isAccountHolder: boolean,
}

const initialState: Readonly<GocardlessState> = {
  bank: '',
  billingDay: '',
  sortCode: '',
  accountNumber: '',
  accountHolderName: '',
  isAccountHolder: true,
};

export const gocardlessSlice = createSlice({
  name: 'gocardless',
  initialState,
  reducers: {
    updateGocardlessFields(state: GocardlessState, action: PayloadAction<Partial<GocardlessState>>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setIsAccountHolder(state: GocardlessState, action: PayloadAction<boolean>) {
      return {
        ...state,
        isAccountHolder: action.payload,
      };
    },
    setBankName(state: GocardlessState, action: PayloadAction<string>) {
      return {
        ...state,
        bank: action.payload,
      };
    },
  },
  extraReducers: builder => builder.addCase(resetJourney, () => initialState),
});

export const {
  updateGocardlessFields,
  setIsAccountHolder,
  setBankName,
} = gocardlessSlice.actions;
